// Predefined task type options shown in the Task creation/edit form.
// "Otros" triggers a free-text input. The final value stored in DB is either
// one of the predefined strings or the custom text typed by the admin
// (without any "Otros: " prefix), so it stays clean for future reports.

export const TASK_TYPE_OTHERS = "Otros";

export const TASK_TYPE_OPTIONS = [
  "Crear logo / diseño",
  "Ordenar ropa",
  "Ordenar blanks",
  "Hacer mockup",
  "Enviar diseño listo para imprimir",
  "Imprimir DTF",
  "Imprimir sublimación",
  "Digitalizar logo para bordado",
  "Vectorizar logo",
  "Pegar DTF",
  "Pegar sublimación",
  "Mandar impresión a terceros",
  "Instalar letrero",
  "Imprimir letrero",
  "Grabar parche en láser",
  "Cortar letras para letrero en láser",
  "Pegar parches de cuero",
  "Hacer bordado",
  "Grabar con láser",
  TASK_TYPE_OTHERS,
];
